import { FleetAreaCode, PermissionCode } from '@gb-ticket/shared-types';
import { Loader2Icon } from 'lucide-react';
import { Navigate, Outlet } from 'react-router';

import { hasPermission } from '@/platform/auth/permissions';
import { useMe } from '@/platform/auth/use-me';
import { fleetAreaOn, useFleetAreas } from '@/products/fleet/features/use-fleet-areas';
import {
  FLEET_OPERATIONS_COSTS_PATH,
  FLEET_OPERATIONS_FUEL_PATH,
  FLEET_OPERATIONS_MAP_PATH,
  FLEET_ROOT,
} from '@/products/fleet/fleet-paths';

function Pending() {
  return (
    <p className="flex items-center gap-2 text-muted-foreground">
      <Loader2Icon className="size-4 animate-spin" aria-hidden />
      Wird geladen …
    </p>
  );
}

export function FleetOperationsGate() {
  const me = useMe();
  const areas = useFleetAreas();
  const catalog = areas.isError ? undefined : areas.data;
  const allowed =
    (hasPermission(me.data, PermissionCode.FLEET_TELEMATICS_READ) &&
      fleetAreaOn(catalog, FleetAreaCode.TELEMATICS)) ||
    (hasPermission(me.data, PermissionCode.FLEET_FUEL_READ) &&
      fleetAreaOn(catalog, FleetAreaCode.FUEL)) ||
    (hasPermission(me.data, PermissionCode.FLEET_WORKSHOP_MANAGE) &&
      fleetAreaOn(catalog, FleetAreaCode.WORKSHOP));

  if (me.isPending || areas.isPending) {
    return <Pending />;
  }

  if (!allowed) {
    return <Navigate to={FLEET_ROOT} replace />;
  }

  return <Outlet />;
}

export function FleetCostsGate() {
  const me = useMe();
  const areas = useFleetAreas();
  const catalog = areas.isError ? undefined : areas.data;
  const allowed =
    (hasPermission(me.data, PermissionCode.FLEET_WORKSHOP_MANAGE) &&
      fleetAreaOn(catalog, FleetAreaCode.WORKSHOP)) ||
    (hasPermission(me.data, PermissionCode.FLEET_FUEL_READ) &&
      fleetAreaOn(catalog, FleetAreaCode.FUEL));

  if (me.isPending || areas.isPending) {
    return <Pending />;
  }

  if (!allowed) {
    return <Navigate to={FLEET_ROOT} replace />;
  }

  return <Outlet />;
}

export function FleetOperationsIndex() {
  const me = useMe();
  const areas = useFleetAreas();
  const catalog = areas.isError ? undefined : areas.data;

  if (me.isPending || areas.isPending) {
    return <Pending />;
  }

  if (
    hasPermission(me.data, PermissionCode.FLEET_TELEMATICS_READ) &&
    fleetAreaOn(catalog, FleetAreaCode.TELEMATICS)
  ) {
    return <Navigate to={FLEET_OPERATIONS_MAP_PATH} replace />;
  }
  if (
    hasPermission(me.data, PermissionCode.FLEET_FUEL_READ) &&
    fleetAreaOn(catalog, FleetAreaCode.FUEL)
  ) {
    return <Navigate to={FLEET_OPERATIONS_FUEL_PATH} replace />;
  }
  if (
    hasPermission(me.data, PermissionCode.FLEET_WORKSHOP_MANAGE) &&
    fleetAreaOn(catalog, FleetAreaCode.WORKSHOP)
  ) {
    return <Navigate to={FLEET_OPERATIONS_COSTS_PATH} replace />;
  }
  return <Navigate to={FLEET_ROOT} replace />;
}
